export const useGetNotificationPermissions: typeof import('./useGetNotificationPermissions').useGetNotificationPermissions =
  () => undefined
